import { EXTERNAL_PATH, PORTAL_PATH } from '../../../../../routes/paths';
import { CheckIfUserHasPortalPrivilege } from '../../../../../common/client-status/interfaces';

import { MenuSection, MenuItem } from './interfaces';

export const isMenuItemSelected = (link: PORTAL_PATH | EXTERNAL_PATH, pathname: string): boolean =>
  link.split('/')[1] === pathname.split('/')[1];

export const getUserMenu = (
  initMenuConfig: MenuSection[],
  checkIfUserHasPortalPrivilege: CheckIfUserHasPortalPrivilege
): MenuSection[] =>
  initMenuConfig.reduce((reducedMenuConfig, menuCategory, index) => {
    const reducedMenuCategory = menuCategory.menuItems.reduce((reducedMenuItems, menuItem) => {
      if (menuItem.excludeFromNavigation) {
        return reducedMenuItems;
      }

      if (menuItem.portalPrivilegeVerification(checkIfUserHasPortalPrivilege)) {
        reducedMenuItems.push(menuItem);
      }

      return reducedMenuItems;
    }, [] as MenuItem[]);

    if (!reducedMenuCategory || reducedMenuCategory.length === 0) {
      return reducedMenuConfig;
    }

    reducedMenuConfig.push({ title: initMenuConfig[index].title, menuItems: reducedMenuCategory });

    return reducedMenuConfig;
  }, [] as MenuSection[]);
